/**
 * 权限指令 v-permission
 * 用法：
 *   <el-button v-permission="'member:export'">导出</el-button>
 *   <el-button v-permission="['member:export', 'order:export']">导出</el-button>
 *
 * 当当前用户没有对应权限标识时，自动移除该 DOM 元素
 */
import store from '@/store'

function checkPermission(el, binding) {
  const { value } = binding
  const permissions = store.state.user.permissions || []

  if (value) {
    // 支持字符串或数组
    const requiredPerms = Array.isArray(value) ? value : [value]
    const hasPermission = requiredPerms.some(perm => permissions.includes(perm))

    if (!hasPermission && el.parentNode) {
      el.parentNode.removeChild(el)
    }
  } else {
    throw new Error('需要指定权限标识，如 v-permission="\'member:export\'"')
  }
}

export default {
  inserted(el, binding) {
    checkPermission(el, binding)
  },
  update(el, binding) {
    checkPermission(el, binding)
  }
}
